import { render, staticRenderFns } from "./SearchFormat.vue?vue&type=template&id=5f0f3a08&"
import script from "./SearchFormat.vue?vue&type=script&lang=js&"
export * from "./SearchFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports